import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterDemandeDevis {
    id: number;
    mesDemandes?: boolean;
    page?: number;
    sort?: string[];
}

class DemandeDevisService {
    public async getDemandesDevis(params: FilterDemandeDevis): Promise<any> {
        return http.get(Routes.DemandeDevisRoutes.GetListDemandeDevis(), { params });
    }
    public async getDemandeDevis(id: number): Promise<any> {
        return http.get(Routes.DemandeDevisRoutes.GetDemandeDevis(id));
    }
    public async getPieceJointeById(id: number): Promise<any> {
        return http.get(Routes.DemandeDevisRoutes.GetPieceJointeById(id), {responseType: 'arraybuffer'});
    }
    public async getExportXlsDemandeDevis(params: FilterDemandeDevis): Promise<any> {
        return http.get(Routes.DemandeDevisRoutes.GetExportXlsDemandeDevis(), { params, responseType: 'arraybuffer' });
    }
    public async supprimerDemandeDevis(id: number): Promise<any> {
        return http.delete(Routes.DemandeDevisRoutes.DeleteDemandeDevis(id));
    }
}

export default new DemandeDevisService();
